/** @type {import('tailwindcss').Config} */
module.exports = {
	content: [],
	purge: ['./index.html', './src/**/*.{vue,js,ts,jsx,tsx}'],
	theme: {
		fontFamily: {
			'display': ['Righteous', 'sans-serif'],
			'body': ['Roboto', 'sans-serif'],
		},
		extend: {
			colors: {
				'blue-1': '#4FA2DE',
				'blue-2': '#98C6E7',
				'blue-3': '#E4F4FF',
				'brown-1': '#7D6E49',
				'brown-2': '#E0D7C1',
				'brown-3': '#DDC791',

				'back-white': "#FFFFFF",

				'primary-1': '#0090A4',
				'primary-2': '#3EB6C6',
				'primary-3': '#DEEEF0',

				'secondary-1': '#E0D7C1',
				'secondary-2': '#F99190',

				transparent: {
					'lobster': '#F9919066',
					'lavender': '#D9D1EA66',
					'sea': '#9EDAE366',
					'olive': '#A0B41666',
					'gallery': '#EEA71555',
				},

				pastel: {
					'red': '#ff7f7f',
					'orange': '#ffb07f',
					'green': '#7fff7f',
					'blue': '#7fbfff',
					'purple': '#bf7fff',
					'pink': '#ff7fbf',
					'teal': '#7fffbf',
				},

				'lobster': '#F99190',
				'lavender': '#C4B6E6',
				'sea': '#9EDAE3',
				'olive': '#A0B416',
				'orange': '#EEA715',
				'gallery': '#EEA715',
			},
			fontSize: {
				'clamp-sm': 'clamp(1.1rem, 3vw, 1.8rem)',
				'clamp-md': 'clamp(0.875rem, 4vw, 4rem)',
				'clamp-lg': 'clamp(3.5rem, 10vw, 6.5rem)',
			},
		},
	},
	plugins: [],
	safelist: [
		{
			pattern: /(bg|text|border)-(lobster|lavender|sea|olive|gallery|brown-1|brown-2|brown-3|blue-1|blue-2|blue-3)/,
		},
		{
			pattern: /(bg|text|border)-transparent-(lobster|lavender|sea|olive|gallery)/,
		},
		{
			pattern: /(bg|text|border)-(primary|secondary)-(1|2|3)/,
		},
	],
}

